// extracted by mini-css-extract-plugin
export var container = "footer-module--container--29F0B";
export var footerDetails = "footer-module--footerDetails--1pm7D";
export var copyright = "footer-module--copyright--1B3BS";
export var developer = "footer-module--developer--CVzjA";